import { useMutation } from '@tanstack/react-query';
import { RawDraftContentState } from 'draft-js';
import { editTextInTextWidget } from '../../helpers/api/guidelinesApi';
import { WIDGET_TYPE } from '../../types';
import {
  handleMutationSuccess,
  optimisticallyUpdateWidget,
  updateGuideVersion,
} from '../helpers';
import { useGuideStore } from '../../stores/guideStore';

export const useTextWidgetMutation = (
  sectionId: string,
  widgetId: string,
  columnIndex: number,
) => {
  const activeGuideId = useGuideStore(s => s.activeGuideId) as string;
  const activePageId = useGuideStore(s => s.activePageId) as string;
  const activeChapterId = useGuideStore(s => s.activeChapterId) as string;
  const activeGuideVersion = useGuideStore(s => s.activeGuideVersion) as number;

  return {
    editTextWidget: useMutation(
      ({ widgetText }: { widgetText: RawDraftContentState }) => {
        return editTextInTextWidget(
          activeGuideId,
          activeChapterId,
          activePageId,
          sectionId,
          widgetId,
          WIDGET_TYPE.TEXT,
          { widgetText },
          activeGuideVersion,
        );
      },
      {
        onMutate: variables => {
          updateGuideVersion(activeGuideId);
          optimisticallyUpdateWidget(
            activeGuideId,
            activePageId,
            sectionId,
            columnIndex,
            widgetId,
            WIDGET_TYPE.TEXT,
            variables.widgetText,
          );
        },
        onSuccess: data => {
          handleMutationSuccess('Text Widget Edited', data, {
            entityId: activeGuideId,
          });
        },
      },
    ),
  };
};
